import { createModel } from "@rematch/core";
import axios from "axios";
import * as logger from "../utils/logger";
import {
  pageEndHandle,
  dialogSize,
  updateChallengeId4Native,
} from "../service/jsbridge";
import { getCaptchaData, postCaptchaData } from "../service/captcha";
import { isNative } from "../utils/constants";
import { getQuery } from "../utils/utils";
import * as slardar from "@/utils/lib/slardar";
import { handlerCallBack } from "@/utils/callBack";
import { getGraphicsData } from "@/utils/detect/graphics";
import checkHook from "@/utils/detect/hook";
import { getBattery } from "@/utils/battery";
import { checkIsDebugger } from "@/utils/checkDebugger";
import { getCanvasHash } from "@/utils/detect/canvas";
import { getPluginHash } from "@/utils/detect/plugins";
import CryptoJS from "crypto-js";

import {
  TrackPoint,
  MouseUpEvent,
  ClickEvent,
  FocusEvent,
  TouchEvent,
  MoveEvent,
  DeviceOrientationEvent,
  SlideEvent,
} from "./eventType";
type msgType = { type: string; time: number; enter_x: number; enter_y: number };
let isFirstOpenError = true;

const MAX_NUM = 500;
const currentTime = Date.now();
const deviceAsyncObj = {
  isCharge: false,
  debugInfo: "",
  canvasHash: "",
};
const defaultState = {
  server_version: 0, // 在后端未上线的时候前端先行，先根据服务器版本适配旧版
  uuid: new Date().getTime(),
  question_url: "", // 问题的图片
  answer_url: "", // 答案的图片
  outer_url: "", // 双环验证码 外圆图片
  inner_url: "", // 双环验证码 内圆图片
  backup_url1: [] as string[],
  backup_url2: [] as string[],
  backup_url1Index: -1,
  backup_url2Index: -1,
  isFetch: true, // 区分是提交中状态还是获取内容中的状态，icon及尺寸不一样
  loading: false, // 素材loading态
  selected_pos: [] as Point[], // 文字和3d点选的坐标点
  mode: "", // text| 3d | 'slide' , // 验证码类型, text: 文字点选,3d:3d点选,slide:滑块
  challenge_mode: "", // 有哪些值？
  challenge_id: "", // 验证码id
  verify_status: "init" as "fail" | "pass" | "init", // 验证状态，init:尚未验证，going:正在验证,pass: 验证通过， fail: 验证失败
  start_time: 0, // 滑块滑动起始时间
  drag_pos: {
    x: 0,
    y: 0,
  }, // 滑块滑动位置
  drag_track: [] as ({
    relative_time: number;
  } & Point)[], // 滑动轨迹
  verify_result_msg: "", // 保存验证结果信息
  show_verify_msg: false, // 展示验证信息

  sliding: false, // 滑动中
  // verifying: false, // 用 verify_status === going 代替 验证中
  // refreshing: false, // 刷新中 检查 loading 状态即可

  point_add_able: false, // 是否可以点击图片，添加小圆点
  confirm_btn_able: false, // 确定按钮是否可以按
  slide_btn_able: false, // 滑动按钮是否可以拖动
  feedback_btn_able: true, // 反馈按钮是否可以点击
  refresh_btn_able: true, // 刷新按钮是否可以使用
  isTooFrequently: false,
  codifica: "", //string 值为字符串 'true' 时开启请求加密灰度
  cyfreso: 0,
  voice_status: "normal", // 语音验证码验证码状态 正常 normal | 验证成功 verify_succeed | 验证失败 verify_fail | 加载错误 load_error | 播放失败 play_error | 网络错误 network_error | 频繁验证 verify_frequently
  voice_loading_load: false, // 语音验证码 加载状态的 loading
  voice_loading_verify: false, // 语音验证码 验证状态的 loading
  init_time: Date.now(),
  modified_img_width: 0,
  reply: [] as TrackPoint[],
  drag_width: 0,
  postData: {
    hk: checkHook() ? 1 : 0, //hook 是否命中
    lo: {
      referer: document?.referrer || "", //--referer
      location: location?.href || "", //--当前的url
      topref: parent?.location?.href || "", //--使用iframe技术时，父页面地址
      frame: window.self === window.top ? 0 : 1, //--验证码是否是通过frame后iframe加载的
    },
    br: window?.navigator?.userAgent, //浏览器版本 型号
    bt: { status: 0 }, //--是否在充电，1是充电中，0是未充电
    si: {
      bodyClientHeight: document?.body?.clientHeight || 0,
      screenWidth: window?.screen?.width || 0,
      innerHeight: window.innerHeight,
      screenHeight: window?.screen?.height || 0,
      screenLeft: window?.screenLeft,
      outerWidth: window?.outerWidth,
      clientHeight: document?.documentElement?.clientHeight || 0,
      innerWidth: window?.innerWidth || 0,
      bodyClientWidth: document?.body?.clientWidth || 0,
      availWidth: window?.screen?.availWidth || 0,
      clientWidth: document?.documentElement?.clientWidth || 0,
      outerHeight: window?.outerHeight || 0,
      docClientWidth: document?.documentElement?.clientWidth || 0,
      screenTop: window?.screenTop || 0,
      availHeight: window?.screen?.availHeight || 0,
      docClientHeight: document?.documentElement?.clientHeight || 0,
    },
    vci: getGraphicsData(), //显卡数据,
    cc: { ndi: 0, debugInfo: "false" },
    fi: [] as FocusEvent[], //fouces 事件
    mc: [] as ClickEvent[],
    mu: [] as MouseUpEvent[], //鼠标抬起
    tc: [] as TouchEvent[], //touch事件
    tu: [] as TouchEvent[], //touch抬起事件
    mm: [] as SlideEvent[], //滑动轨迹
    ugt: 0, //上报数据和验证码加载完的时间差,
    tmv: [] as MoveEvent[], // 手指拖动轨迹
    mp: [] as MoveEvent[], // 鼠标拖动轨迹,
    gy: [] as DeviceOrientationEvent[], // 陀螺仪数据,
    cp: { p: getPluginHash(), c: "" },
    hash: "",
    tk: "", //--数据上报时间
    tm: currentTime, //        --初始化时间
  },
};
const logState = {
  // 记录日志所需
  verify_failure_frequency: 0, // 验证失败次数
  refresh_frequency: 0, // 点击刷新按钮次数
  submit_btn_frequency: 0, // 点击确定按钮的次数
  rootDivLeft: 0, // 验证框左上角相对于视图的位置
  rootDivTop: 0,
  enter_slide_bar_msg: {} as msgType, // 保留最后一次进入验证框的位置
  enter_verify_dialog_msg: {} as msgType, // 保留最后一次进入滑块范围的位置
  slide_btn_track: [] as {
    // 滑块的运动轨迹 --- slide
    x: number;
    y: number;
    time: number;
  }[],
  mouse_track: [] as {
    // 鼠标在图形区域的轨迹 --- text/3d
    x: number;
    y: number;
    relative_time: number;
  }[],
};
// 此处适合放一些不受刷新验证码影响的数据
const ImmutableState = {
  // 不需要 reset 但是也不属于 logState
  type: "",
  challenge_code: 3058,
  for_3d_bar_text: "", // 保存3d验证的特殊文本
  isOpen: true, // 弹窗开关
};

type CaptchaState = typeof defaultState &
  typeof logState &
  typeof ImmutableState;
export const captcha = createModel({
  state: Object.assign(
    // 此处适合放一些不受刷新验证码影响的数据
    ImmutableState,
    defaultState,
    logState
  ),
  reducers: {
    reset(state: CaptchaState) {
      return Object.assign({}, state, defaultState);
    },
    hide(state: CaptchaState) {
      state.isOpen = false;
      return state;
    },
    show(state: CaptchaState) {
      state.isOpen = true;
      return state;
    },
    addPos(state: CaptchaState, point) {
      state.selected_pos.push(point);
      state.confirm_btn_able = true;
    },
    removePos(state: CaptchaState, idx) {
      state.selected_pos = state.selected_pos.slice(0, idx);
      if (idx === 0) {
        state.confirm_btn_able = false;
      }
    },
    update(state: CaptchaState, props: Partial<CaptchaState>) {
      state = { ...state, ...props };
      return state;
    },
    updateLoading(state: CaptchaState, loading) {
      state.loading = loading;
    },
    updateVerifyStatus(state: CaptchaState, verify_status) {
      state.verify_status = verify_status;
    },
    updateDragPos(state: CaptchaState, pos: Point) {
      state.drag_pos = { ...state.drag_pos, ...pos };
    },
    appendTrack(state: CaptchaState, pos: Point & { relative_time: number }) {
      state.drag_track.push(pos);
    },
    slidingToggle(state: CaptchaState, sliding: boolean) {
      state.sliding = sliding;
    },
    // 修改日志数据
    verifyFailureIncrease(state: CaptchaState) {
      state.verify_failure_frequency++;
      return state;
    },
    refreshIncrease(state: CaptchaState) {
      state.refresh_frequency++;
      return state;
    },
    clickSubmitIncrease(state: CaptchaState) {
      state.submit_btn_frequency++;
      return state;
    },
    keepRootDivPos(state: CaptchaState, pos: { left: number; top: number }) {
      state.rootDivLeft = pos.left;
      state.rootDivTop = pos.top;
    },
    keepeEnterSlideBarMsg(state: CaptchaState, msgObj: msgType) {
      state.enter_slide_bar_msg = msgObj;
    },
    keepEnterVerifyDialogMsg(state: CaptchaState, msgObj: msgType) {
      state.enter_verify_dialog_msg = msgObj;
    },
    slideTrackIncrease(
      state: CaptchaState,
      msgObj: { x: number; y: number; time: number }
    ) {
      msgObj.x = Number(msgObj.x.toFixed(3)) - 0;
      msgObj.y = Number(msgObj.y.toFixed(3)) - 0;
      state.slide_btn_track.push(msgObj);
    },
    setMouseTrack(
      state: CaptchaState,
      mouse_track: { x: number; y: number; relative_time: number }[]
    ) {
      state.mouse_track = mouse_track;
    },
    //验证码轨迹信息存储到 state
    trackIncrease(
      state: CaptchaState,
      msgObj: { x: number; y: number; relative_time: number }
    ) {
      if (state.mouse_track.length >= 500) {
        state.mouse_track.shift();
      }
      msgObj.x = Number(msgObj.x.toFixed(3)) - 0;
      msgObj.y = Number(msgObj.y.toFixed(3)) - 0;
      state.mouse_track.push(msgObj);
    },
    trackFocus(state: CaptchaState, focusEvent: FocusEvent) {
      if (state.postData.fi.length >= MAX_NUM) {
        state.postData.fi.shift();
      }
      state.postData.fi.push(focusEvent);
    },
    trackClick(state: CaptchaState, clickEvent: ClickEvent) {
      if (state.postData.mc.length >= MAX_NUM) {
        state.postData.mc.shift();
      }
      state.postData.mc.push(clickEvent);
    },
    trackMouseUp(state: CaptchaState, mouseUpEvent: MouseUpEvent) {
      if (state.postData.mu.length >= MAX_NUM) {
        state.postData.mu.shift();
      }
      state.postData.mu.push(mouseUpEvent);
    },
    trackTouchStart(state: CaptchaState, touchEvent: TouchEvent) {
      if (state.postData.tc.length >= MAX_NUM) {
        state.postData.tc.shift();
      }
      state.postData.tc.push(touchEvent);
    },
    trackTouchEnd(state: CaptchaState, touchEvent: TouchEvent) {
      if (state.postData.tu.length >= MAX_NUM) {
        state.postData.tu.shift();
      }
      state.postData.tu.push(touchEvent);
    },
    trackMouseMove(state: CaptchaState, moveEvent: MoveEvent) {
      if (state.postData.mp.length >= MAX_NUM) {
        state.postData.mp.shift();
      }
      state.postData.mp.push(moveEvent);
    },
    trackTouchMove(state: CaptchaState, moveEvent: MoveEvent) {
      if (state.postData.tmv.length >= MAX_NUM) {
        state.postData.tmv.shift();
      }
      state.postData.tmv.push(moveEvent);
    },
    trackDevice(
      state: CaptchaState,
      deviceOrientEvent: DeviceOrientationEvent
    ) {
      if (state.postData.gy.length >= MAX_NUM) {
        state.postData.gy.shift();
      }
      state.postData.gy.push(deviceOrientEvent);
    },
    trackSlide(state: CaptchaState, dragEvent: SlideEvent) {
      if (state.postData.mm.length >= MAX_NUM) {
        state.postData.mm.shift();
      }
      state.postData.mm.push(dragEvent);
    },
    setUgt(state: CaptchaState, time: number) {
      state.postData.ugt = time;
    },
    setIsCharge(state: CaptchaState, isCharge: string) {
      state.postData.bt.status = isCharge ? 1 : 0;
    },
    setDebugInfo(state: CaptchaState, isDebugger: boolean) {
      state.postData.cc.debugInfo = String(isDebugger);
    },
    setCanvasInfo(state: CaptchaState, canvasHash: string) {
      state.postData.cp.c = canvasHash;
    },
    setPostTime(state: CaptchaState, time: string) {
      try {
        const hash = CryptoJS.SHA256(JSON.stringify(state)).toString();
        state.postData.tk = String(time) + ":" + hash;
      } catch (error) {
        state.postData.tk = String(time);
      }
    },
    setModifiedImgWidth(state: CaptchaState, modifiedImgWidth: number) {
      state.modified_img_width = modifiedImgWidth;
    },
    setDragWidth(state: CaptchaState, dragWidth: number) {
      state.drag_width = dragWidth;
    },
    setReply(state: CaptchaState, reply: TrackPoint[]) {
      state.reply = reply;
    },
  },
  effects: ({ captcha }) => ({
    async init() {
      getBattery().then((res) => {
        deviceAsyncObj.isCharge = res;
      });
      checkIsDebugger().then((res) => {
        deviceAsyncObj.debugInfo = String(res);
      });
      const res = getCanvasHash();
      deviceAsyncObj.canvasHash = String(res);
      // console.log('res',res);
      // captcha.setCanvasInfo(String(res));
    },
    async submit(
      {
        query,
        text,
        challenge_code,
        duration,
        sideSlide,
        autoClose,
        drag_type,
      },
      rootState
    ) {
      captcha.setPostTime(Date.now());
      captcha.updateVerifyStatus("going");
      captcha.update({
        point_add_able: false,
        confirm_btn_able: false,
        slide_btn_able: false,
        refresh_btn_able: false,
        show_verify_msg: true,
        loading: true,
        verify_result_msg: "",
      });
      const start_time = Date.now();
      console.log("submit", deviceAsyncObj);
      console.log("submit rootState", rootState);

      const data = {
        id: rootState.captcha.challenge_id,
        mode: rootState.captcha.mode,
        drag_width: rootState.captcha.drag_width,
        modified_img_width: rootState.captcha.modified_img_width,
        reply: rootState.captcha.reply,
        ...rootState.captcha.postData,
        bt: {
          ...rootState.captcha.postData.bt,
          status: deviceAsyncObj.isCharge ? 1 : 0,
        },
        cc: {
          ...rootState.captcha.postData.cc,
          debugInfo: deviceAsyncObj.debugInfo,
        },
        cp: {
          ...rootState.captcha.postData.cp,
          c: deviceAsyncObj.canvasHash,
        },
      };
      try {
        console.log("postData", data);
        const result = await postCaptchaData(
          data,
          {
            params: query,
          },
          {
            codifica: rootState.captcha.codifica,
            cyfreso: rootState.captcha.cyfreso,
          }
        );
        logger.trackEvent("result", {
          drag_type,
          mode: data.mode,
          challenge_code,
          challenge_id: data.id,
          duration: Date.now() - start_time,
          is_success: 1,
          msg: "",
        });
        captcha.update({
          loading: false,
          verify_status: "pass",
          show_verify_msg: true,
          verify_result_msg: result.message,
        });

        setTimeout(() => {
          if (sideSlide === "disabled") {
            // 关闭验证码之后恢复滑动
            console.log("bytedance://enable_swipe"); // eslint-disable-line
          }
          // JSBridge
          const qs_hash = getQuery(window.location.search);
          const app_env =
            qs_hash["os_type"] === "0" || qs_hash["os_type"] === "1";
          if (app_env) {
            try {
              pageEndHandle({
                challenge_id: data.id,
                challenge_mode: data.mode,
                challenge_code,
                verifyResultType: 0,
                closeType: "verify_success_close",
                duration,
              });
            } catch (err) {}
          } else {
            const isHaveCb = handlerCallBack("successCb", result);
            if (isHaveCb) {
              logger.trackEvent("close", {
                mode: data.mode,
                challenge_id: data.id,
                challenge_code,
                style: "verify_success_close",
                duration,
              });
              if (autoClose !== false) {
                slardar.close();
                captcha.hide();
                // clearCallBack();
              }
            }
          }
        }, 1000);
      } catch (err) {
        logger.trackEvent("result", {
          drag_type,
          mode: data.mode,
          challenge_id: data.id,
          challenge_code,
          duration: Date.now() - start_time,
          msg: err.message,
          is_success: 0,
        });
        handlerCallBack("errorCb", err);
        const { code } = err;
        // code === 'JSBERROR' jsb 本身的错误，不是服务端报错，目前没有文案，显示网络错误 + [5102]
        let tip_msg = "";
        if (code && code !== "ECONNABORTED") {
          if (code === "JSBERROR") {
            tip_msg = text.net_error + "[5102]";
          } else if (code === "EncryptError") {
            tip_msg = text.net_error + "[5101]";
          } else {
            tip_msg = err.message;
          }
        } else {
          tip_msg = text.net_error;
        }
        if (code === 500) {
          const newState: Obj = {
            loading: false,
            verify_status: "fail",
            show_verify_msg: true,
            verify_result_msg: tip_msg,
          };
          captcha.update(newState);
          captcha.verifyFailureIncrease();
          setTimeout(() => {
            captcha.refresh({ query, challenge_code, text });
          }, 1000);
        } else {
          captcha.update({
            loading: false,
            show_verify_msg: true,
            // verify_status: 'error',
            verify_result_msg: tip_msg,
            refresh_btn_able: true,
          });
        }
      } finally {
        captcha.update({
          feedback_btn_able: true,
        });
      }
    },
    async refresh({ query, challenge_code, text }, rootState) {
      // captcha.reset();
      captcha.update({
        isFetch: true, // 区分是提交中状态还是获取内容中的状态，icon及尺寸不一样
        loading: true,
        show_verify_msg: true,
        verify_result_msg: text.loading,
        refresh_btn_able: false,
        slide_btn_able: false,
      });
      // 日志 --- /get 接口请求资源记录
      const start_time = new Date().getTime();
      try {
        let result = await getCaptchaData(query);
        if (
          !(result && result.code === 502 && rootState.captcha.mode === "whirl")
        ) {
          captcha.reset();
          captcha.update({
            isFetch: true, // 区分是提交中状态还是获取内容中的状态，icon及尺寸不一样
            loading: true,
            show_verify_msg: true,
            verify_result_msg: text.loading,
            refresh_btn_able: false,
          });
        }
        //针对MT动态调度就近访问问题重发请求
        if (result.data.host) {
          logger.setScheduling(true);
          axios.defaults.baseURL = result.data.host;
          result = await getCaptchaData(query);
        }
        if (isFirstOpenError) isFirstOpenError = false;
        const data = result.data;
        const question = data.question;
        logger.setParams({
          flag: data.flag ?? 0, // 0代表不进AI对抗模型灰度
        });
        logger.trackEvent("aquire_data", {
          mode: rootState.captcha.mode,
          challenge_id: data.id,
          duration: Date.now() - start_time,
          is_success: 1,
          msg: "",
        });
        captcha.update({
          server_version: data.version || 0,
          uuid: new Date().getTime(),
          codifica: data.codifica || "",
          cyfreso: data.cyfreso || 0,
          backup_url1: question.backup_url1 || [],
          backup_url2: question.backup_url2 || [],
          backup_url1Index: question.backup_url1
            ? question.backup_url1.length - 1
            : -1,
          backup_url2Index: question.backup_url2
            ? question.backup_url2.length - 1
            : -1,
        });
        // 3d 验证的特殊文
        if (data.mode === "3d") {
          captcha.update({ for_3d_bar_text: data.question.ques });
        }
        const { url1, url2, tip_y } = data.question;
        if (data.mode === "whirl") {
          captcha.update({
            type: data.mode,
            challenge_code: data.challenge_code,
            outer_url: url1,
            inner_url: url2,
            challenge_id: data.id,
            mode: data.mode,
            challenge_mode: data.mode,
            drag_pos: {
              x: 0,
              y: 0,
            },
          });
        } else {
          captcha.update({
            type: data.mode,
            challenge_code: data.challenge_code,
            question_url: url1,
            answer_url: url2,
            challenge_id: data.id,
            mode: data.mode,
            challenge_mode: data.mode,
            drag_pos: {
              x: 0,
              y: tip_y,
            },
          });
        }
        // 更新 challenge_id 后同步给 native 端
        if (isNative) {
          try {
            updateChallengeId4Native(data.id);
          } catch (err) {}
        }
      } catch (err) {
        // if (!(err && err.code === 502 && rootState.captcha.mode === 'whirl')) {
        captcha.reset();
        captcha.update({
          isFetch: true, // 区分是提交中状态还是获取内容中的状态，icon及尺寸不一样
          loading: true,
          show_verify_msg: true,
          verify_result_msg: text.loading,
          refresh_btn_able: false,
        });
        // }
        /**
         * 这里是为了解决初始化时请求失败native的弹窗高度（这个高度为上次关闭验证码时的高度）可能和浏览器默认设置的"slide"的高度不一致的，可能会造成验证码内部滚动
         * 弹出页面，请求失败的话，设置弹框高度为331（dialogSize不传参数，高度设置为331）
         */
        if (isFirstOpenError && isNative) {
          isFirstOpenError = false;
          dialogSize();
        }
        const { code } = err;
        logger.trackEvent("aquire_data", {
          mode: rootState.captcha.mode,
          duration: Date.now() - start_time,
          is_success: 0,
          msg: err.message,
        });
        // code === 'JSBERROR' jsb 本身的错误，不是服务端报错，目前没有文案，显示网络错误
        let tip_msg = "";
        if (code && code !== "ECONNABORTED") {
          if (code === "JSBERROR") {
            tip_msg = text.net_error + "[5102]";
          } else {
            tip_msg = err.message;
          }
        } else {
          tip_msg = text.net_error;
        }
        let timeout = code === 502 ? 10000 : 0; // 52 请求过于频繁，10000ms后允许刷新
        captcha.update({
          isTooFrequently: code === 502,
          show_verify_msg: true,
          // verify_status: 'error',
          verify_result_msg: tip_msg,
        });
        setTimeout(() => {
          captcha.update({ refresh_btn_able: true });
        }, timeout);
        captcha.updateLoading(false);
      } finally {
        // captcha.updateLoading(false);
      }
    },
  }),
});
